export default "__VITE_ASSET__DitFfsAc__"